import { Analytics } from "@/lib/segment";
import { AnalyticsEvent } from "@/lib/segment/constants";
import { KeyColors } from "@/theme/colors";
import { css } from "styled-components";

export const buttonBaseStyles = css<{
  $color: KeyColors;
}>`
  ${({ theme, $color = "black" }) => `
    border-radius: 24px;
    color: ${theme.Colors[$color]};
    font-family: ${theme.Fonts.ttNormsProBold};
    font-size: 16px;
    line-height: 24px;
    padding: 10px 0px 10px;
    width: 100%;
    max-width: 320px;
`}
`;

export const onClickWithAnalytics = (
  onClick: () => void,
  ctx: Record<string, unknown>
) => {
  Analytics.trackEvent(AnalyticsEvent.BUTTON_CLICKED, {
    ...ctx,
  });
  onClick();
};
